
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faFileAlt, faSignOutAlt, faTable, faTimes, faHome, faStepBackward } from "@fortawesome/free-solid-svg-icons";
import { Nav, Badge, Image, Button, Dropdown, Accordion, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import { isSuperAdminUser } from "../helper/adminSession";
import ReactHero from "../assets/img/technologies/react-hero-logo.svg";
import ProfilePicture from "../assets/img/team/profile-picture-3.jpg";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const permission = localStorage.getItem('permission')
  const superAdmin = isSuperAdminUser()

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";

    return (
      <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button as={Nav.Link} className="d-flex justify-content-between align-items-center">
            <span>
              <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level">
            <Nav className="flex-column">
              {children}
            </Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  };

  const NavItem = (props) => {
    const { title, link, external, target, icon, image, badgeText, badgeBg = "secondary", badgeColor = "primary" } = props;
    const classNames = badgeText ? "d-flex justify-content-start align-items-center justify-content-between" : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span> : null}
            {image ? <Image src={image} width={20} height={20} className="sidebar-icon svg-icon" /> : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge pill bg={badgeBg} text={badgeColor} className="badge-md notification-count ms-2">{badgeText}</Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  const permissionPoint = permission.split('').reduce((x, it) => {
    return parseInt(x) + parseInt(it)
  })

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Overview.path}>
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image src={ProfilePicture} className="card-img-top rounded-circle border-white" />
                </div>
                <div className="d-block">
                  <h6>Hi, Jane</h6>
                  <Button as={Link} variant="secondary" size="xs" to={Routes.Signin.path} className="text-dark">
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              {(permissionPoint > 1) &&
                <NavItem title="Quay về" link={Routes.Overview.path} icon={faStepBackward} />
              }

              <NavItem title="Trang chủ" link={Routes.CustomerOverview.path} icon={faHome} />

              <CollapsableNavItem eventKey="/customer/charge/" title="Nạp tiền" icon={faTable}>
                <NavItem title="Nạp tiền" link={Routes.CustomerAddCharge.path} />
                <NavItem title="Lịch sử nạp tiền" link={Routes.CustomerChargeHistory.path} />
                <NavItem title="Lỗi nạp tiền" link={Routes.CustomerIssueCharge.path} />
                <NavItem title="Thống kê" link={Routes.CustomerChargeSummary.path} />
                <NavItem title="Cài đặt nạp tiền" link={Routes.CustomerChargeSettings.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/customer/refund/" title="Thu hồi" icon={faTable}>
                <NavItem title="Thu hồi" link={Routes.CustomerRefund.path} />
                <NavItem title="Lịch sử thu hồi" link={Routes.CustomerRefundHistory.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/customer/cashback/" title="Hoàn tiền" icon={faTable}>
                <NavItem title="Lịch sử hoàn tiền" link={Routes.CustomerCashbackHistory.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <NavItem title="Lịch sử dòng tiền" link={Routes.CustomerMoneyLogHistory.path} icon={faBook} />
              <NavItem title="Đối soát dòng tiền" link={Routes.CustomerMoneyLogLink.path} icon={faBook} />

              <Dropdown.Divider className="my-3 border-indigo" />

              <CollapsableNavItem eventKey="/customer/withdraw/" title="Rút tiền" icon={faTable}>
                <NavItem title="Yêu cầu rút tiền" link={Routes.CustomerWithdrawRequest.path} />
                {superAdmin &&
                  <NavItem title="Cài đặt rút tiền" link={Routes.CustomerWithdrawSettings.path} />
                }
                <NavItem title="Yêu cầu đã hoàn thành" link={Routes.CustomerWithdrawRequestConfirmed.path} />
                <NavItem title="Lịch sử rút tiền" link={Routes.CustomerWithdrawSummary.path} />
              </CollapsableNavItem>

              <Dropdown.Divider className="my-3 border-indigo" />

              <NavItem title="K/H mới đăng ký" link={Routes.CustomerNewUserSummary.path} />

              <Dropdown.Divider className="my-3 border-indigo" />

              <NavItem title="Khách hàng" link={Routes.CustomerUser.path} />

              <Dropdown.Divider className="my-3 border-indigo" />
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
